var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpener(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10676_111118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4615 -0.000467954C11.905 -0.109331 11.458 0.119573 10.9722 0.363302C10.9005 0.398186 10.8287 0.432952 10.7568 0.467595C10.599 0.543783 10.4418 0.62107 10.2851 0.699451C10.2556 0.7134 10.2262 0.727348 10.1959 0.74172C10.1579 0.762463 10.12 0.783207 10.0809 0.80458C9.86651 0.894756 9.6353 0.874081 9.40682 0.872077C9.3277 0.87211 9.24859 0.872144 9.16948 0.872187C9.08486 0.872127 9.00025 0.871784 8.91564 0.871368C8.739 0.87054 8.56238 0.870729 8.38574 0.871097C7.88362 0.871989 7.38151 0.871523 6.87939 0.870036C6.60173 0.869224 6.32408 0.86925 6.04643 0.870174C5.87088 0.870709 5.69537 0.870195 5.51982 0.868901C5.38502 0.868209 5.25024 0.869041 5.11544 0.869636C5.06689 0.868974 5.01835 0.868313 4.96833 0.867631C4.92376 0.868113 4.87919 0.868594 4.83326 0.86909C4.79462 0.86901 4.75598 0.86893 4.71617 0.868847C4.56679 0.909796 4.49254 1.00386 4.41462 1.13234C4.39023 1.26367 4.39023 1.26367 4.39026 1.41015C4.38987 1.45093 4.38987 1.45093 4.38947 1.49253C4.38884 1.58363 4.38959 1.67466 4.39034 1.76575C4.39017 1.83171 4.38992 1.89767 4.38959 1.96364C4.38892 2.1449 4.38948 2.32613 4.39023 2.50739C4.39084 2.70287 4.39031 2.89834 4.38993 3.09381C4.38936 3.47673 4.38984 3.85965 4.39068 4.24257C4.39161 4.6883 4.39155 5.13402 4.39145 5.57975C4.3913 6.37491 4.39212 7.17007 4.39345 7.96522C4.39474 8.73719 4.39529 9.50915 4.39505 10.2811C4.39479 11.1214 4.39488 11.9616 4.39565 12.8018C4.39571 12.8685 4.39571 12.8685 4.39577 12.9364C4.39586 13.0256 4.39594 13.1148 4.39602 13.204C4.39629 13.5149 4.39632 13.8258 4.39626 14.1366C4.3962 14.5153 4.39658 14.894 4.39751 15.2727C4.39797 15.466 4.39825 15.6593 4.39802 15.8526C4.39782 16.0294 4.39816 16.2062 4.39893 16.3831C4.39912 16.4471 4.3991 16.5112 4.39888 16.5753C4.3986 16.6622 4.39903 16.7491 4.39965 16.836C4.39972 16.8843 4.39978 16.9327 4.39984 16.9825C4.41607 17.1213 4.44771 17.1936 4.53181 17.3042C4.67288 17.3983 4.73658 17.3915 4.90412 17.39C4.95432 17.3897 5.00453 17.3895 5.05625 17.3892C5.1093 17.3886 5.16235 17.3879 5.2154 17.3872C5.26845 17.3868 5.3215 17.3865 5.37455 17.3862C5.47183 17.3855 5.5691 17.3846 5.66638 17.3836C6.11638 17.3788 6.47362 17.5308 6.87556 17.7193C6.93221 17.7455 6.98887 17.7716 7.04555 17.7977C7.22356 17.88 7.40115 17.9631 7.57868 18.0464C7.63646 18.0735 7.69423 18.1005 7.752 18.1276C8.00566 18.2465 8.25913 18.3659 8.51245 18.4855C8.93162 18.6835 9.35236 18.878 9.77354 19.0716C9.95297 19.1542 10.1322 19.237 10.3115 19.3199C10.3806 19.3518 10.4496 19.3837 10.5186 19.4156C10.6212 19.463 10.7238 19.5104 10.8264 19.5578C10.9223 19.6022 11.0181 19.6464 11.114 19.6907C11.1423 19.7038 11.1706 19.7169 11.1997 19.7303C11.2541 19.7554 11.3085 19.7804 11.363 19.8053C11.4216 19.8322 11.4801 19.8594 11.5385 19.8868C11.5691 19.901 11.5998 19.9151 11.6313 19.9297C11.6589 19.9426 11.6865 19.9555 11.7149 19.9688C11.8574 20.0219 11.9962 20.0208 12.1466 20.0166C12.176 20.0169 12.2054 20.0172 12.2357 20.0175C12.321 20.0165 12.321 20.0165 12.4615 19.9995C12.5538 19.861 12.5491 19.8036 12.5485 19.6395C12.5485 19.5895 12.5485 19.5395 12.5485 19.4879C12.5481 19.4333 12.5477 19.3787 12.5472 19.324C12.5471 19.2681 12.547 19.2123 12.5469 19.1564C12.5466 19.0094 12.5458 18.8624 12.545 18.7154C12.5442 18.5654 12.5438 18.4153 12.5434 18.2653C12.5426 17.971 12.5413 17.6767 12.5396 17.3823C12.5863 17.3823 12.6331 17.3823 12.6812 17.3823C13.1939 17.3823 13.7066 17.3823 14.2193 17.3823C14.3034 17.3842 14.3876 17.386 14.4717 17.3878C14.5483 17.3889 14.6248 17.39 14.7014 17.3909C14.7542 17.3917 14.807 17.3928 14.8598 17.3941C14.9363 17.396 15.0128 17.3968 15.0894 17.3976C15.1351 17.3984 15.1807 17.3992 15.2278 17.4001C15.3775 17.3787 15.4406 17.3309 15.5474 17.2261C15.604 17.113 15.5915 17.0152 15.5916 16.8888C15.5917 16.8617 15.5918 16.8346 15.5919 16.8067C15.5921 16.7151 15.592 16.6235 15.592 16.5319C15.5921 16.4659 15.5922 16.3999 15.5923 16.3339C15.5926 16.1519 15.5927 15.9698 15.5927 15.7878C15.5928 15.5917 15.5931 15.3956 15.5934 15.1996C15.5939 14.7705 15.5941 14.3415 15.5943 13.9125C15.5944 13.6447 15.5946 13.377 15.5948 13.1093C15.5952 12.3686 15.5956 11.6279 15.5958 10.8871C15.5958 10.816 15.5958 10.816 15.5958 10.7434C15.5958 10.6958 15.5958 10.6483 15.5958 10.5993C15.5958 10.5029 15.5959 10.4066 15.5959 10.3102C15.5959 10.2624 15.5959 10.2146 15.5959 10.1653C15.5961 9.3905 15.5967 8.61567 15.5977 7.84083C15.5986 7.04598 15.5991 6.25113 15.5991 5.45627C15.5991 5.00973 15.5994 4.56318 15.6001 4.11664C15.6007 3.73644 15.6009 3.35625 15.6006 2.97605C15.6004 2.78196 15.6004 2.58788 15.601 2.39379C15.6015 2.21623 15.6014 2.03868 15.601 1.86112C15.6009 1.79677 15.601 1.73242 15.6014 1.66807C15.6018 1.5808 15.6015 1.49355 15.601 1.40628C15.6011 1.33348 15.6011 1.33348 15.6011 1.2592C15.5852 1.12107 15.5525 1.04734 15.4693 0.937032C15.3535 0.87914 15.2497 0.893313 15.1205 0.893535C15.0788 0.893526 15.0788 0.893526 15.0362 0.893518C14.9441 0.893545 14.8519 0.893849 14.7598 0.894155C14.696 0.894228 14.6321 0.894283 14.5683 0.894322C14.4002 0.894472 14.2321 0.894855 14.0639 0.895287C13.8924 0.895687 13.7209 0.895865 13.5494 0.896062C13.2128 0.896481 12.8762 0.897148 12.5396 0.89797C12.54 0.874917 12.5404 0.851864 12.5409 0.828113C12.5425 0.723633 12.5435 0.619156 12.5445 0.514669C12.5452 0.478389 12.5458 0.442109 12.5465 0.404729C12.5467 0.369859 12.547 0.334989 12.5472 0.299062C12.5477 0.266946 12.5481 0.234829 12.5485 0.20174C12.5396 0.11672 12.5396 0.11672 12.4615 -0.000467954Z",
    fill: "#FF809C"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_10676_111118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.88281 0.898302C9.19862 0.892826 8.51443 0.888693 7.83022 0.886158C7.51253 0.88495 7.19485 0.883302 6.87716 0.88062C6.60027 0.878284 6.32338 0.876772 6.04648 0.87625C5.89986 0.875944 5.75326 0.875226 5.60664 0.873521C5.44296 0.871633 5.27933 0.871585 5.11563 0.871694C5.06702 0.870851 5.01842 0.870009 4.96834 0.869141C4.90138 0.869624 4.90138 0.869624 4.83306 0.870117C4.79435 0.869901 4.75565 0.869685 4.71577 0.869462C4.56614 0.910023 4.49201 1.0041 4.41406 1.13268C4.38967 1.264 4.38967 1.264 4.3897 1.41048C4.38944 1.43767 4.38918 1.46485 4.38891 1.49287C4.38828 1.58396 4.38904 1.67499 4.38979 1.76608C4.38962 1.83204 4.38936 1.89801 4.38903 1.96397C4.38837 2.14523 4.38892 2.32647 4.38968 2.50772C4.39028 2.7032 4.38975 2.89867 4.38937 3.09414C4.38881 3.47707 4.38928 3.85998 4.39012 4.2429C4.39106 4.68863 4.39099 5.13436 4.39089 5.58009C4.39074 6.37524 4.39156 7.1704 4.39289 7.96555C4.39418 8.73752 4.39474 9.50949 4.39449 10.2815C4.39423 11.1217 4.39432 11.9619 4.39509 12.8022C4.39513 12.8466 4.39517 12.891 4.39522 12.9368C4.3953 13.026 4.39538 13.1152 4.39546 13.2044C4.39573 13.5152 4.39576 13.8261 4.3957 14.137C4.39565 14.5156 4.39602 14.8943 4.39695 15.273C4.39741 15.4663 4.39769 15.6596 4.39746 15.8529C4.39726 16.0297 4.3976 16.2066 4.39837 16.3834C4.39856 16.4475 4.39855 16.5116 4.39832 16.5756C4.39804 16.6626 4.39848 16.7494 4.3991 16.8363C4.39919 16.9088 4.39919 16.9088 4.39928 16.9828C4.41552 17.1217 4.44715 17.1939 4.53125 17.3046C4.67172 17.3982 4.73667 17.3927 4.90356 17.3931C4.95377 17.3932 5.00397 17.3933 5.05569 17.3934C5.08181 17.3932 5.10792 17.393 5.13483 17.3929C5.21456 17.3924 5.29426 17.3929 5.37399 17.3934C5.4242 17.3933 5.4744 17.3932 5.52612 17.3931C5.57222 17.393 5.61832 17.3929 5.66582 17.3928C5.78125 17.3827 5.78125 17.3827 5.89844 17.3046C5.91299 17.2282 5.91299 17.2282 5.91286 17.1327C5.91309 17.0963 5.91332 17.06 5.91356 17.0225C5.91322 16.9823 5.91288 16.9421 5.91253 16.9007C5.91263 16.8582 5.91273 16.8157 5.91283 16.7719C5.91303 16.6286 5.91238 16.4852 5.91174 16.3419C5.91171 16.2395 5.91173 16.1371 5.91179 16.0347C5.91185 15.8138 5.91149 15.5929 5.91083 15.372C5.90988 15.0526 5.90957 14.7332 5.90942 14.4138C5.90917 13.8956 5.90839 13.3775 5.90728 12.8593C5.9062 12.3559 5.90537 11.8524 5.90487 11.349C5.90484 11.318 5.90481 11.287 5.90478 11.255C5.90463 11.0994 5.90448 10.9438 5.90433 10.7882C5.90312 9.49678 5.90105 8.20536 5.89844 6.91393C5.98867 6.91393 6.07891 6.91393 6.17188 6.91393C6.17188 6.16627 6.17188 5.41861 6.17188 4.6483C6.08164 4.6483 5.99141 4.6483 5.89844 4.6483C5.89844 3.90065 5.89844 3.15299 5.89844 2.38268C6.19492 2.38268 6.49141 2.38268 6.79688 2.38268C7.04054 2.2959 7.25156 2.20812 7.47559 2.08727C7.53504 2.05694 7.5946 2.02683 7.65425 1.9969C7.74598 1.95081 7.83761 1.90457 7.92891 1.85764C8.25103 1.69204 8.5805 1.544 8.91113 1.39635C9.23824 1.24958 9.56392 1.10144 9.88281 0.937364C9.88281 0.924473 9.88281 0.911583 9.88281 0.898302Z",
    fill: "#C83B5A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_10676_111118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.117 0.894358C15.0747 0.89435 15.0747 0.89435 15.0315 0.894341C14.9381 0.894368 14.8447 0.894672 14.7512 0.894978C14.6865 0.895051 14.6218 0.895107 14.5571 0.895146C14.3867 0.895295 14.2163 0.895679 14.0458 0.896111C13.8414 0.89658 13.637 0.89676 13.4326 0.896988C13.1219 0.897367 12.8112 0.898115 12.5006 0.898793C12.5006 1.38864 12.5006 1.87848 12.5006 2.38317C13.0291 2.38317 13.5576 2.38317 14.1021 2.38317C14.1019 2.56994 14.1016 2.75671 14.1013 2.94913C14.099 4.66011 14.0973 6.37108 14.0961 8.08205C14.096 8.3061 14.0958 8.53014 14.0957 8.75419C14.0957 8.79879 14.0956 8.8434 14.0956 8.88936C14.0951 9.61249 14.0942 10.3356 14.0931 11.0588C14.092 11.8003 14.0913 12.5417 14.0911 13.2832C14.0909 13.7411 14.0904 14.199 14.0895 14.6569C14.0889 14.9704 14.0887 15.284 14.0888 15.5976C14.0889 15.7788 14.0888 15.96 14.0882 16.1411C14.0876 16.3068 14.0875 16.4724 14.088 16.638C14.088 16.6982 14.0879 16.7583 14.0875 16.8185C14.087 16.8998 14.0873 16.9811 14.0877 17.0624C14.0877 17.1077 14.0876 17.153 14.0876 17.1997C14.0924 17.2344 14.0972 17.2692 14.1021 17.305C14.2867 17.4281 14.4841 17.3977 14.7014 17.3976C14.7803 17.3978 14.8591 17.3992 14.938 17.4007C14.9879 17.4009 15.0379 17.401 15.0894 17.4012C15.1351 17.4015 15.1807 17.4018 15.2278 17.4021C15.3769 17.3794 15.4408 17.3313 15.5474 17.2269C15.604 17.1138 15.5915 17.016 15.5916 16.8896C15.5917 16.8625 15.5918 16.8355 15.5919 16.8076C15.5921 16.7159 15.592 16.6243 15.592 16.5327C15.5921 16.4667 15.5922 16.4007 15.5923 16.3347C15.5926 16.1527 15.5927 15.9706 15.5927 15.7886C15.5928 15.5925 15.5931 15.3965 15.5934 15.2004C15.5939 14.7714 15.5941 14.3423 15.5943 13.9133C15.5944 13.6456 15.5946 13.3778 15.5948 13.1101C15.5952 12.3694 15.5956 11.6287 15.5958 10.888C15.5958 10.8168 15.5958 10.8168 15.5958 10.7442C15.5958 10.6967 15.5958 10.6491 15.5958 10.6001C15.5958 10.5037 15.5959 10.4074 15.5959 10.311C15.5959 10.2632 15.5959 10.2154 15.5959 10.1662C15.5961 9.39133 15.5967 8.61649 15.5977 7.84165C15.5986 7.0468 15.5991 6.25195 15.5991 5.4571C15.5991 5.01055 15.5994 4.56401 15.6001 4.11746C15.6007 3.73726 15.6009 3.35707 15.6006 2.97687C15.6004 2.78279 15.6004 2.5887 15.601 2.39461C15.6015 2.21706 15.6014 2.0395 15.601 1.86195C15.6009 1.79759 15.601 1.73324 15.6014 1.66889C15.6018 1.58162 15.6015 1.49438 15.601 1.4071C15.6011 1.3343 15.6011 1.3343 15.6011 1.26003C15.5852 1.12189 15.5525 1.04816 15.4693 0.937855C15.3527 0.879542 15.247 0.894138 15.117 0.894358Z",
    fill: "#C83B5A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_10676_111118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1016 2.38281C13.573 2.38281 13.0445 2.38281 12.5 2.38281C12.5 7.33281 12.5 12.2828 12.5 17.3828C13.0285 17.3828 13.557 17.3828 14.1016 17.3828C14.1016 12.4328 14.1016 7.48281 14.1016 2.38281Z",
    fill: "url(#paint0_linear_10676_111118)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.458 0C12.2646 0 12.0713 0 11.872 0C11.872 6.6 11.872 13.2 11.872 20C12.0654 20 12.2588 20 12.458 20C12.5571 19.8513 12.5469 19.7323 12.5459 19.56C12.5461 19.5098 12.5461 19.5098 12.5463 19.4586C12.5466 19.3454 12.5463 19.2323 12.546 19.1191C12.5461 19.0376 12.5462 18.956 12.5464 18.8745C12.5467 18.6496 12.5466 18.4248 12.5463 18.1999C12.5461 17.9577 12.5464 17.7155 12.5466 17.4733C12.547 17.0259 12.5469 16.5786 12.5467 16.1313C12.5465 15.7181 12.5465 15.3049 12.5466 14.8917C12.5466 14.8643 12.5466 14.837 12.5466 14.8088C12.5466 14.6976 12.5466 14.5865 12.5466 14.4754C12.5469 13.4323 12.5467 12.3893 12.5462 11.3462C12.5459 10.4189 12.5459 9.49166 12.5463 8.56438C12.5467 7.52327 12.5469 6.48216 12.5466 5.44105C12.5466 5.33013 12.5466 5.2192 12.5466 5.10828C12.5465 5.08096 12.5465 5.05365 12.5465 5.02551C12.5464 4.61251 12.5466 4.19951 12.5467 3.78651C12.547 3.31705 12.5469 2.84759 12.5465 2.37813C12.5463 2.1384 12.5462 1.89868 12.5465 1.65895C12.5467 1.43979 12.5466 1.22063 12.5462 1.00147C12.5461 0.921902 12.5461 0.842332 12.5463 0.762764C12.5465 0.655161 12.5463 0.547569 12.5459 0.439967C12.5461 0.408597 12.5463 0.377228 12.5465 0.344908C12.5455 0.195926 12.5427 0.127037 12.458 0Z",
    fill: "#FF476F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16924 6.91406C6.079 6.91406 5.98877 6.91406 5.8958 6.91406C5.8958 10.3688 5.8958 13.8234 5.8958 17.3828C5.99892 17.3828 6.10205 17.3828 6.2083 17.3828C6.20957 16.7879 6.21031 16.193 6.21074 15.5981C6.21077 15.5519 6.21081 15.5056 6.21084 15.458C6.21206 13.5418 6.20164 11.6257 6.18877 9.70947C6.18853 9.67468 6.1883 9.63988 6.18806 9.60403C6.18204 8.70737 6.17577 7.81072 6.16924 6.91406Z",
    fill: "#D84A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 6.91406C6.09453 6.91406 6.01719 6.91406 5.9375 6.91406C5.9375 8.93789 5.9375 10.9617 5.9375 13.0469C6.01484 13.0469 6.09219 13.0469 6.17188 13.0469C6.17188 11.023 6.17188 8.99922 6.17188 6.91406Z",
    fill: "url(#paint1_linear_10676_111118)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_10676_111118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8606 9.45292C10.6712 9.54944 10.5798 9.64286 10.509 9.84355C10.4792 10.0734 10.5357 10.2421 10.6652 10.4295C10.7718 10.5192 10.8387 10.5429 10.9753 10.5662C11.1406 10.5392 11.2134 10.4699 11.3293 10.3514C11.4307 10.1855 11.4348 9.99366 11.4074 9.80449C11.2801 9.55883 11.1481 9.41267 10.8606 9.45292Z",
    fill: "#C83B5A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_10676_111118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 4.64844C6.08164 4.64844 5.99141 4.64844 5.89844 4.64844C5.89844 5.39609 5.89844 6.14375 5.89844 6.91406C5.98867 6.91406 6.07891 6.91406 6.17188 6.91406C6.17188 6.16641 6.17188 5.41875 6.17188 4.64844Z",
    fill: "#C83B5A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.71875 2.38281C6.46094 2.38281 6.20313 2.38281 5.9375 2.38281C5.9375 3.11758 5.9375 3.85234 5.9375 4.60938C6.01484 4.60938 6.09219 4.60938 6.17188 4.60938C6.17188 3.95195 6.17188 3.29453 6.17188 2.61719C6.23633 2.6043 6.30078 2.59141 6.36719 2.57812C6.43058 2.55303 6.4933 2.52619 6.55518 2.49756C6.58604 2.48341 6.61691 2.46926 6.64871 2.45468C6.67182 2.44386 6.69494 2.43303 6.71875 2.42188C6.71875 2.40898 6.71875 2.39609 6.71875 2.38281Z",
    fill: "url(#paint2_linear_10676_111118)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_10676_111118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 13.0469C6.09453 13.0469 6.01719 13.0469 5.9375 13.0469C5.9375 13.7945 5.9375 14.5422 5.9375 15.3125C6.01484 15.3125 6.09219 15.3125 6.17188 15.3125C6.17188 14.5648 6.17188 13.8172 6.17188 13.0469Z",
    fill: "#FF5379"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 15.3516C6.09453 15.3516 6.01719 15.3516 5.9375 15.3516C5.92461 16.0219 5.91172 16.6922 5.89844 17.3828C5.98867 17.3828 6.07891 17.3828 6.17188 17.3828C6.17188 16.7125 6.17188 16.0422 6.17188 15.3516Z",
    fill: "url(#paint3_linear_10676_111118)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_10676_111118",
    x: 4.39062,
    y: 0.869141,
    width: 5.49219,
    height: 20.5244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.846154 0 0 0 0 0.288831 0 0 0 0 0.413672 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10676_111118"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_10676_111118",
    x: 12.5,
    y: 0.892578,
    width: 3.10156,
    height: 20.5098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.846154 0 0 0 0 0.288831 0 0 0 0 0.413672 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10676_111118"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_10676_111118",
    x: 8.5,
    y: 2.38281,
    width: 9.60156,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10676_111118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10676_111118",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_10676_111118",
    x: 10.5,
    y: 9.44629,
    width: 0.921875,
    height: 5.12012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.846154 0 0 0 0 0.288831 0 0 0 0 0.413672 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10676_111118"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_10676_111118",
    x: 5.89844,
    y: 4.64844,
    width: 0.273438,
    height: 6.26562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.846154 0 0 0 0 0.288831 0 0 0 0 0.413672 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10676_111118"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_10676_111118",
    x: 5.9375,
    y: 13.0469,
    width: 0.234375,
    height: 6.26562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.846154 0 0 0 0 0.288831 0 0 0 0 0.413672 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10676_111118"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10676_111118",
    x1: 13.3008,
    y1: 17.3828,
    x2: 13.3008,
    y2: 2.38281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F06180"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10676_111118",
    x1: 6.05469,
    y1: 13.0469,
    x2: 6.05469,
    y2: 6.91406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1708D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10676_111118",
    x1: 6.32812,
    y1: 4.60938,
    x2: 6.32812,
    y2: 2.38281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10676_111118",
    x1: 6.03516,
    y1: 17.3828,
    x2: 6.03516,
    y2: 15.3516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3809A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10676_111118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 20 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpener);
export default __webpack_public_path__ + "static/media/opener.b072fad978c4571cca8e69d740b91714.svg";
export { ForwardRef as ReactComponent };